import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-performa-invoice-form',
  templateUrl: './performa-invoice-form.component.html',
  styleUrls: ['./performa-invoice-form.component.css']
})
export class PerformaInvoiceFormComponent implements OnInit {
  title="Performa Invoice";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/sales-orders/performa-invoice/performa-invoice-form/performa-invoice-form.component.ts